import type { WorkspaceBadge } from "../api.js";

// ——— L'insigne d'un espace : son initiale, sa teinte, ses cercles (testé) ————————————————————————

/** L'initiale d'un espace (« 🍞 Mie câline » → « M »), comme les pastilles de compte Google. */
export function initialOf(name: string): string {
  return (name.match(/[\p{L}\p{N}]/u)?.[0] ?? "?").toUpperCase();
}
/** La teinte de la pastille, stable (même calcul que l'iPhone, `WorkspaceBadge.tint`). */
export function tintOf(name: string, count: number): number {
  let hash = 5381n;
  for (const ch of name.toLowerCase()) hash = (hash * 33n + BigInt(ch.codePointAt(0)!)) % 2n ** 64n;
  return Number(hash % BigInt(count));
}

/**
 * Les cercles de l'insigne : les comptes (photo, sinon réseau), puis l'icône du site ; trois au plus. Sans aucune image
 * (que des logos), l'initiale passe devant : les logos sont ceux de tout le monde, l'initiale dit quel espace c'est.
 */
export function badgeCircles(
  badge?: WorkspaceBadge,
): { key: string; platform?: string; src?: string; site?: boolean; initial?: boolean }[] {
  const accounts = badge?.accounts ?? (badge?.avatars ?? []).map((avatar) => ({ platform: "", avatar }));
  const items = [
    ...accounts.map((a) => ({ key: `${a.platform}:${a.avatar ?? ""}`, platform: a.platform, src: a.avatar })),
    ...(badge?.siteIcon ? [{ key: badge.siteIcon, src: badge.siteIcon, site: true }] : []),
  ].slice(0, 3);
  const initial = { key: "initial", initial: true };
  if (!items.length) return [initial];
  return items.some((c) => c.src) ? items : [initial, ...items];
}
